<template>
	<div class="slidemenu-container titlemenu-phone">
        <div>
		<swiper :options="mySwiperOption" class="contanter-box">
			<swiper-slide v-for="(item,index) in menuarray" :key="index" :class="pid == item.id ? 'active slide' : 'slide' ">
                <span class="slidemenu-line0" @click="onClick(item)"> {{item.title}}</span> <span class="slidemenu-line1">|</span>
			</swiper-slide>
		</swiper>
        </div>
	</div>
</template>
 
<script>
	// 局部引入 vue-awesome-swiper 及其样式
	import {	swiper,swiperSlide} from 'vue-awesome-swiper'
	//import 'swiper/dist/css/swiper.css'
	export default {
		name: 'SlideMenu',
		components: {
			// 注册 vue-awesome-swiper 组件
			swiper,
			swiperSlide
		},
        props:{
            menuarray: Array,
			pid:String
        },
		data() {
			return {
				mySwiperOption: {
                    slidesPerView: 3,
                    freeMode:true,
					//自动播放
					autoplay: false,
                    loop: false,
                    spaceBetween : 1,
                    observer: true,
                    observeParents: true,
				},
				
                
			}
		},
		methods:{
			onClick:function(t){
				this.$emit('gotolist',t);
			}
		}
	}
</script>

<style scoped>
.contanter-box{
    width: 100%;
    height: 24px;
    /* background-color: bisque; */
}
.slide{
    text-align: left;
    width: auto !important;
    height: 24px;
    /* background-color: cadetblue; */
}
.slidemenu-line1 {margin-left: 16px;  margin-right: 16px;}
.contanter-box .swiper-wrapper .active .slidemenu-line0 {font-size: 14px;
    background-color: white;
    color: #083286;
    font-weight: bold;}
</style>
 